module.exports = __webpack_public_path__ + "static/media/banner.198b21f5.png";